const yoigoNegocios2 = [
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_ADICIONAL",
        "tarifa": {
            "id": "CONTFHD999GTP06",
            "price": 64,
            "name": "Fibra 1 GB + La Sinfín Infinitos PRO",
            "operator": "YOIGO",
            "segment": "NEGOCIOS",
            "category": "convergent",
            "color": "blue",
            "commercial_enrichment": {
                "commercial_name": "FIBRA 1 GB + LA SINFÍN GB ∞ PRO"
            },
            "description_file": null,
            "fixed_line_info": {
                "type": "fiber",
                "price": {
                    "base_fee": 25
                },
                "owners": [
                    "MASMOVIL"
                ],
                "upload_speed": {
                    "unit": "Mb",
                    "amount": 300
                },
                "download_speed": {
                    "unit": "Gb",
                    "amount": 1
                },
                "voice_to_fixed": {
                    "unit": "min",
                    "amount": -1
                },
                "voice_to_mobile": {
                    "unit": "min",
                    "amount": -1
                }
            },
            "mobile_line_info": {
                "price": {
                    "base_fee": 39
                },
                "mobile_line_data": {
                    "unit": "MB",
                    "amount": -1
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": -1
                }
            },
            "payment_type": "postpaid",
            "is_active": true,
            "created_on": "2022-05-25T00:45:13.938041+02:00",
            "updated_on": "2022-05-25T00:45:13.946057+02:00",
            "svas": [
                "AGILETV_0_PREMIUMSERDDD001",
                "AGILETV_0_PREMIUMSERDDD002",
                "FAX2EMAILSERDDD001",
                "IPFIJASERDDD001",
                "OFFICE365SERDDD001",
                "SMARTHOMESERDDD001"
            ],
            "promotions": [
                "PROMOYOIGO10",
                "PROMOYOIGO13",
                "PROMOYOIGO15",
                "PROMOYOIGO23",
                "PROMOYOIGO24",
                "PROMOYOIGO25",
                "PROMOYOIGO27",
                "PROMOYOIGO32"
            ],
            "additional_lines": [
                "CONT025GP",
                "CONT060GP01",
                "CONT28",
                "CONT29",
                "NLADUO(ADICIONAL)PROYOIGO",
                "NLADUO(PRINCIPAL)PROYOIGO",
                "NLASINFIN25GBADICIONALPROYOIGO",
                "NLASINFIN60GBADICIONALPROYOIGO",
                "NLASINFINGIGASINFINITOSADICIONALPROYOIGO"
            ]
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOYOIGO13",
                "duration": 0,
                "name": "Descuento Multisede 10",
                "duration_unit": null,
                "amount": "10.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": "Tiene que tener contratada al menos una convergente PRO de Gigas Infinitos o 40Gb",
                "operator": "YOIGO"
            },
            {
                "id": "PROMOYOIGO27",
                "duration": 3,
                "name": "Convergente 1Gb A Precio 300Mb PRO",
                "duration_unit": "month",
                "amount": "12.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": "Valido para altas nuevas o portabilidades de fijo y movil",
                "operator": "YOIGO"
            }
        ]
    },
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_PRINCIPAL",
        "tarifa": {
            "id": "NLADUO(PRINCIPAL)PROYOIGO",
            "price": 2.48,
            "max_number": 1,
            "mobile_line_info": null,
            "name": "La Dúo (PRINCIPAL) PRO",
            "operator": "YOIGO",
            "segment": "NEGOCIOS",
            "is_active": true,
            "created_on": "2022-05-25T00:45:13.847433+02:00",
            "updated_on": "2022-05-25T00:45:13.858077+02:00",
            "promotions": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    }
]
export default yoigoNegocios2;